export const REQUEST_ADD_EVENTS: 'EVENTS/ADD' = 'EVENTS/ADD';
export const REQUEST_FLUSH_EVENTS_BY_TYPE_ID: 'EVENTS/FLUSH_EVENTS/TYPE_ID' = 'EVENTS/FLUSH_EVENTS/TYPE_ID';
export const REQUEST_FLUSH_EVENT_BY_IDS: 'EVENTS/FLUSH_EVENTS/IDS' = 'EVENTS/FLUSH_EVENTS/IDS';
export const REQUEST_FLUSH_EVENTS: 'EVENTS/REQUEST_FLUSH_EVENTS' = 'EVENTS/REQUEST_FLUSH_EVENTS';
export const REQUEST_ASYNC_EVENTS: 'EVENTS/REQUEST_ASYNC_EVENTS' = 'EVENTS/REQUEST_ASYNC_EVENTS';
export const REQUEST_ASYNC_EVENTS_SUCCESS: 'EVENTS/REQUEST_ASYNC_EVENTS/SUCCESS' =
	'EVENTS/REQUEST_ASYNC_EVENTS/SUCCESS';
export const REQUEST_ASYNC_EVENTS_FAILURE: 'EVENTS/REQUEST_ASYNC_EVENTS/FAILURE' =
	'EVENTS/REQUEST_ASYNC_EVENTS/FAILURE';
export const DISMISSED_ASYNC_EVENT: 'EVENTS/DISMISSED_ASYNC' = 'EVENTS/DISMISSED_ASYNC';
export const DISMISSED_ASYNC_EVENT_SUCCESS: 'EVENTS/DISMISSED_ASYNC/SUCCESS' = 'EVENTS/DISMISSED_ASYNC/SUCCESS';
export const DISMISSED_ASYNC_EVENT_FAILURE: 'EVENTS/DISMISSED_ASYNC/FAILURE' = 'EVENTS/DISMISSED_ASYNC/FAILURE';
export const REQUEST_CUSTOM_OVERLAYS: 'EVENTS/REQUEST_CUSTOM_OVERLAYS' = 'EVENTS/REQUEST_CUSTOM_OVERLAYS';
export const REQUEST_CUSTOM_OVERLAYS_SUCCESS: 'EVENTS/REQUEST_CUSTOM_OVERLAYS_SUCCESS' =
	'EVENTS/REQUEST_CUSTOM_OVERLAYS_SUCCESS';
export const REQUEST_CUSTOM_OVERLAYS_FAILURE: 'EVENTS/REQUEST_CUSTOM_OVERLAYS_FAILURE' =
	'EVENTS/REQUEST_CUSTOM_OVERLAYS_FAILURE';
export const REQUEST_SAVE_CUSTOM_OVERLAY_SHOWN: 'EVENTS/SAVE_CUSTOM_OVERLAY_SHOWN' = 'EVENTS/SAVE_CUSTOM_OVERLAY_SHOWN';
export const RECEIVED_PROGRAM: 'EVENTS/RECEIVED_PROGRAM' = 'EVENTS/RECEIVED_PROGRAM';
export const RECEIVED_MY_SUCCESS_ITEMS: 'EVENTS/RECEIVED_ITEMS' = 'EVENTS/RECEIVED_ITEMS';
